module.exports = __webpack_public_path__ + "img/bg5.36a2fc54.png";